<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.ACTION.ENTER_CONTAINER_NUMBER' | translate }}"
    icon="fa-shopping-cart"
    [activityType]="activity()?.activityType"
    (closeRequested)="onCloseRequested()"
    [measurementType]="activity()?.measurementType"
    (finishRequested)="onFinishRequested()"
>
    <div header>
        <div class="container-search">
            <input
                priva-input
                [(ngModel)]="containerNumberSearch"
                type="number"
                inputmode="numeric"
                placeholder="{{ 'GENERAL.TITLE.SEARCH_CONTAINER' | translate }}"
                (keydown.enter)="onContainerSelected()"
                [disabled]="!multiple() && containerSelectorStore.selectedContainers().length > 0"
                data-test="container-number-search-bar"
            />
            <button
                priva-button
                importance="primary"
                class="container-search__add"
                (click)="onContainerSelected()"
                [isDisabled]="!multiple() && containerSelectorStore.selectedContainers().length > 0"
                data-test="containers-selected-add-btn"
            >
                {{ 'GENERAL.ACTION.ADD' | translate }}
            </button>
        </div>
        @if (errorMessage) {
            <priva-notification
                status="danger"
                class="container-search__notification"
                [isDismissible]="true"
                (triggerDismiss)="onReset()"
                dataTest="container-selector-error-notification-btn"
                data-test="container-selector-error-notification"
            >
                {{ errorMessage }}
            </priva-notification>
        }
    </div>

    @if (containerSelectorStore.selectedContainers().length) {
        <ng-container data-footer>
            <app-manual-flow-footer
                info="{{
                    'FOOTER.CONTAINER_SELECTION.NUMBER_OF_CONTAINER_SELECTED'
                        | translate: { count: containerSelectorStore.selectedContainers().length }
                }}"
                (next)="onContinueRequested()"
                [hasCancelBtn]="false"
                [nextEnabled]="containerSelectorStore.selectedContainers().length > 0"
                data-test="container-selector-footer"
            />
        </ng-container>
    }

    <div class="containers">
        @if (containerSelectorStore.totalContainers() <= 50) {
            <div class="containers__available">
                <priva-title
                    class="containers__available--title"
                    title="{{ 'GENERAL.TITLE.AVAILABLE_CONTAINERS' | translate }}"
                    size="sm"
                />
                <div class="containers__available--list">
                    <app-container-list
                        [containers]="containerSelectorStore.availableContainers()"
                        (containerClick)="addContainer($event)"
                        data-test="container-table-available"
                    />
                </div>
            </div>
        }
        <div class="containers__selected">
            @if (containerSelectorStore.selectedContainers().length) {
                <priva-title
                    class="containers__selected--title"
                    title="{{ 'GENERAL.TITLE.SELECTED_CONTAINERS' | translate }}"
                    size="sm"
                />
            }
            <div class="containers__selected--list">
                @if (containerSelectorStore.selectedContainers().length) {
                    <app-container-list
                        [containers]="containerSelectorStore.selectedContainers()"
                        [showRemove]="true"
                        (removeContainerClick)="onContainerRemoved($event)"
                        data-test="container-table-selected"
                    />
                }
            </div>
        </div>
    </div>
</app-terminal-overlay>
